// extracted by mini-css-extract-plugin
export default {"default":"_1cICsi91kha1bjQfWJGSTE button","success":"_64STpwyATI9Y8R3e6ahUs7 button success","primary":"_5GMUifIH3Ehyl7EjBt0auh button primary","danger":"_4RiXhxs5kUxWynbRYVdqIs"};